import { createContext } from 'react';

export const ParcoursContext = createContext();
